export default __webpack_public_path__ + "static/media/yes_white.7396430c.svg";